import Notification from './src/main.js';
export default Notification;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/notification/index.js